module.exports = __webpack_public_path__ + "img/pmiamericas.08bc2b4.png";